import { Shield, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

const BENEFITS = [
  "Mantener actualizado el sistema de uso seguro de IA en la clínica",
  "Revisar cambios legales y criterios regulatorios aplicables",
  "Controlar nuevas herramientas antes de incorporarlas",
  "Reducir riesgos antes de que aparezcan incidencias o reclamaciones",
  "Reforzar la trazabilidad y la supervisión interna",
  "Preparar renovaciones, revisiones y mantenimiento del certificado",
];

const INCLUDES = [
  "Seguimiento jurídico del uso de IA en la clínica",
  "Revisión de novedades normativas y criterios regulatorios",
  "Evaluación de nuevas herramientas o nuevas funcionalidades",
  "Actualización de cláusulas, consentimientos y avisos cuando sea necesario",
  "Control documental y recomendaciones prácticas de mejora",
  "Soporte consultivo para dudas sobre campañas, automatizaciones y uso de datos",
  "Revisión periódica del protocolo interno de supervisión humana",
  "Informe periódico con observaciones y acciones recomendadas",
];

export function MantenimientoSection({ scrollToSection }) {
  return (
    <section id="mantenimiento" className="mantenimiento-section" data-testid="mantenimiento-section">
      <div className="container-custom">
        <div className="mantenimiento-badge">Servicio recurrente para clínicas que quieren hacer bien las cosas</div>
        
        <h2 className="mantenimiento-title">Plan de mantenimiento IA segura</h2>
        
        <p className="mantenimiento-intro">
          La auditoría inicial es el primer paso. Pero la inteligencia artificial, las herramientas que utiliza tu clínica y las exigencias legales cambian constantemente. 
          Por eso, tras la auditoría y la emisión del certificado, te ofrecemos un servicio mensual de mantenimiento, control y actualización para que tu clínica no se quede atrás, no improvise y siga utilizando IA con seguridad jurídica, criterio profesional y confianza ante pacientes y colaboradores.
        </p>

        <div className="mantenimiento-grid">
          <div className="mantenimiento-card">
            <h3>Qué conseguimos con este servicio</h3>
            <ul>
              {BENEFITS.map((item) => (
                <li key={item}><Check className="w-4 h-4" />{item}</li>
              ))}
            </ul>
          </div>

          <div className="mantenimiento-card">
            <h3>Qué incluye el mantenimiento mensual</h3>
            <ul>
              {INCLUDES.map((item) => (
                <li key={item}><Check className="w-4 h-4" />{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mantenimiento-highlight">
          <h3>No basta con auditar una vez</h3>
          <p>
            La clínica que usa inteligencia artificial de forma profesional necesita control, revisión y actualización continua. 
            El verdadero valor no está solo en obtener un certificado, sino en mantener la clínica actualizada, supervisada y preparada para seguir utilizando IA con seguridad, confianza y ventaja competitiva real.
          </p>
        </div>

        <div className="mantenimiento-cta">
          <p className="mantenimiento-cta-title">Protege lo que ya has construido y evita quedarte desactualizado</p>
          <p className="mantenimiento-cta-text">
            Nuestro plan mensual te ayuda a validar nuevas herramientas, mantener el cumplimiento, reforzar tu posicionamiento y conservar el valor estratégico del certificado IA segura.
          </p>
          <Button onClick={() => scrollToSection('diagnostico')} className="btn-primary text-base" data-testid="mantenimiento-cta-button">
            <Shield className="w-4 h-4" />
            Quiero proteger y actualizar mi clínica cada mes
          </Button>
        </div>
      </div>
    </section>
  );
}
